// Service pages: /services/:slug
export const SERVICES = [
    {
        slug: 'general-contractor',
        image: '/assets/images/1.webp',
        // Other photos on the page, all different from the hero.
        photos: { feature: '/assets/images/2.webp', cta: '/assets/images/5.webp' },
        name: 'General Contractor Services',
        shortName: 'General Contracting',
        icon: '/assets/icons/s1.png',
        summary: 'We bring your vision to life with reliable, high-quality general contracting services from start to finish.',
        heroText: 'We bring your vision to life with reliable, high-quality general contracting services from start to finish, with permits, trades and scheduling handled by one accountable team.',
        intro: 'As a licensed Florida general contractor, 561-FIX-HOME manages your project from the first walkthrough to the final punch list. We handle permitting, scheduling, trades and quality control so you have one accountable team for the whole job.',
        includes: [
            'Permitting and code compliance',
            'Project planning, scheduling and budgeting',
            'Coordinating licensed trades',
            'Additions, renovations and remodels',
            'Insurance and storm-damage repairs',
            'Final inspections and walkthroughs',
            'Licensed subcontractor management',
            'Change-order tracking and clear updates',
        ],
    },
    {
        slug: 'kitchen-bath-remodeling',
        image: '/assets/images/3.webp',
        // Other photos on the page, all different from the hero.
        photos: { feature: '/assets/images/4.webp', cta: '/assets/images/5.webp' },
        name: 'Kitchen & Bath Remodeling',
        shortName: 'Kitchen & Bath Remodels',
        icon: '/assets/icons/s2.png',
        summary: 'Together, we’ll transform and modernize your kitchen and bathrooms into spaces you’ll love and enjoy every day.',
        intro: 'Kitchens and bathrooms get the most use in your home and add the most value when they are done right. We take on everything from cabinet and countertop swaps to full gut renovations, with clear pricing and timelines.',
        includes: [
            'Full kitchen remodels',
            'Cabinet installation and refacing',
            'Countertops and backsplashes',
            'Bathroom remodels and tub-to-shower conversions',
            'Tile, vanities and fixtures',
            'Plumbing and lighting upgrades',
            'Shower glass and tub installation',
            'Accessibility and grab-bar upgrades',
        ],
    },
    {
        slug: 'interior-exterior-projects',
        image: '/assets/images/1.webp',
        // Other photos on the page, all different from the hero.
        photos: { feature: '/assets/images/5.webp', cta: '/assets/images/2.webp' },
        name: 'Interior & Exterior Projects',
        shortName: 'Interior & Exterior',
        icon: '/assets/icons/s3.png',
        summary: 'We handle all your interior and exterior projects with quality craftsmanship that elevates your home inside and out.',
        intro: 'From fresh paint and new flooring to doors, windows and exterior repairs, we improve how your home looks and performs in the South Florida climate.',
        includes: [
            'Interior and exterior painting',
            'Flooring installation',
            'Drywall installation and repair',
            'Doors, windows and trim',
            'Carpentry and built-ins',
            'Exterior repairs and upgrades',
            'Baseboards, crown molding and trim',
            'Pressure washing and exterior touch-ups',
        ],
    },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
